// extracted by mini-css-extract-plugin
module.exports = {"phone":"EndCall_phone__2kwvb"};